import { useEffect, useState } from 'react'

import { useZustand } from '../../hooks/useZustand'
import { useOnboardingStore } from '../../stores/useOnboardingStore'
import { STAGES } from './copy'

/**
 * True while the post-narration hold is running: the guide shows nothing so
 * the user meets their graph first. When it ends, the graph is brought back to
 * the Topics layer if they wandered off it — the first instruction needs it.
 */
export default function useIntroHold() {
    const holdUntil = useOnboardingStore(state => state.introHoldUntil)
    const [holding, setHolding] = useState(
        () => !!holdUntil && holdUntil > Date.now()
    )

    useEffect(() => {
        const remaining = holdUntil ? holdUntil - Date.now() : 0
        if (remaining <= 0) {
            setHolding(false)
            return
        }
        setHolding(true)
        const timer = window.setTimeout(() => {
            setHolding(false)
            const zustandState = useZustand.getState()
            if (
                useOnboardingStore.getState().stage === STAGES.TOPICS &&
                zustandState.currentGraphMode !== 'topics'
            ) {
                zustandState.setCurrentGraphMode('topics')
            }
        }, remaining)
        return () => window.clearTimeout(timer)
    }, [holdUntil])

    return holding
}
